import FlexRow from "@/components/FlexRow.vue";
import { WrapWithSectionItem } from "../sections";
import TaggedText from "@/components/tableElements/TaggedText.vue";
export default {
  name: "SegmentFilterItem",
  emits: ["select", "selectOnly", "deselect"],
  props: {
    segment: String,
    id: String,
    selected: Boolean
  },
  components: {
    WrapWithSectionItem,
    FlexRow,
    TaggedText
  }
};